var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_82",
    "data-name": "Grupo 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10.733,
    height: 28.409,
    viewBox: "0 0 10.733 28.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_21",
    "data-name": "Ret\\xE2ngulo 21",
    width: 10.733,
    height: 28.409,
    fill: "#35bde8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_81",
    "data-name": "Grupo 81",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_149",
    "data-name": "Caminho 149",
    d: "M8.364,18.775v.391q0,3.718,0,7.436a1.723,1.723,0,0,1-1.515,1.78,1.622,1.622,0,0,1-1.293-.356c-.126-.1-.2-.132-.353-.015a1.648,1.648,0,0,1-1.88.19,1.692,1.692,0,0,1-.952-1.607q0-3.718,0-7.436v-.408a1.959,1.959,0,0,1-1,.1A1.67,1.67,0,0,1,.011,17.211C0,15.994,0,14.776.008,13.559A.51.51,0,0,1,.5,12.981c.3,0,.49.211.492.572,0,1.141,0,2.281,0,3.422a1.31,1.31,0,0,0,.04.423.678.678,0,0,0,1.322-.1,2.6,2.6,0,0,0,.01-.361q0-3.882,0-7.765a1.677,1.677,0,0,1,.011-.328.468.468,0,0,1,.509-.416.461.461,0,0,1,.462.432,2.641,2.641,0,0,1,.008.361q0,8.587,0,17.175a1.411,1.411,0,0,0,.044.488.75.75,0,0,0,1.461-.144,3.176,3.176,0,0,0,.008-.362q0-4.409,0-8.818a1.419,1.419,0,0,1,.018-.36.46.46,0,0,1,.5-.38.457.457,0,0,1,.46.429,2.2,2.2,0,0,1,.007.328q0,4.392,0,8.785a2.921,2.921,0,0,0,.009.361.769.769,0,0,0,.759.685.76.76,0,0,0,.742-.734c.007-.12,0-.241,0-.362q0-8.555,0-17.109a1.805,1.805,0,0,1,.013-.361A.467.467,0,0,1,7.9,8.429a.461.461,0,0,1,.462.466c.008.1,0,.2,0,.3q0,3.866,0,7.732a2.814,2.814,0,0,0,.007.329.682.682,0,0,0,1.363-.031c.011-.153,0-.307,0-.46,0-2.643-.027-5.287.011-7.929a2.582,2.582,0,0,0-1.908-2.7c-.123-.047-.25-.081-.375-.12-.55-.173-.658-.515-.288-.951a2.445,2.445,0,1,0-3.734-.091c.028.034.059.065.087.1.367.433.263.786-.289.954a5,5,0,0,0-.853.338A2.378,2.378,0,0,0,1,8.635c.006.91,0,1.821,0,2.731,0,.4-.167.607-.48.613s-.506-.209-.508-.593c0-.965-.017-1.931,0-2.9A3.3,3.3,0,0,1,2.069,5.422c.265-.127.342-.2.189-.505A3.394,3.394,0,0,1,3.219.744,3.428,3.428,0,0,1,8.434,4.925c-.126.254-.109.337.159.461a3.39,3.39,0,0,1,2.139,3.349c-.021,2.742-.006,5.484-.006,8.225A1.686,1.686,0,0,1,8.45,18.77a.377.377,0,0,0-.085,0",
    transform: "translate(0 -0.001)",
    fill: "#35bde8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdults);
export default __webpack_public_path__ + "static/media/adults.826d41bf981ee21637fd177058641e4f.svg";
export { ForwardRef as ReactComponent };